import type { ElementType, ReactNode } from 'react';

type Accent = 'indigo' | 'amber' | 'emerald' | 'rose';

const accentClasses: Record<Accent, string> = {
  indigo: 'bg-indigo-50 text-indigo-600',
  amber: 'bg-amber-50 text-amber-600',
  emerald: 'bg-emerald-50 text-emerald-600',
  rose: 'bg-rose-50 text-rose-600',
};

interface KpiCardProps {
  label: string;
  value: string | number;
  sublabel?: string;
  /** Extra content shown below the headline value (e.g. KPI drill-down rows). */
  detail?: ReactNode;
  icon: ElementType<{ className?: string }>;
  accent?: Accent;
}

export function KpiCard({
  label,
  value,
  sublabel,
  detail,
  icon: Icon,
  accent = 'indigo',
}: KpiCardProps) {
  return (
    <div className="group relative overflow-hidden rounded-2xl border border-slate-200/60 bg-white p-6 shadow-soft transition-all duration-200 hover:border-slate-200 hover:shadow-glass">
      <div className="flex items-start justify-between">
        <div className="min-w-0 flex-1">
          <p className="text-sm font-medium text-slate-500">{label}</p>
          {sublabel != null && (
            <p className="mt-0.5 text-xs text-slate-400">{sublabel}</p>
          )}
          <p className="mt-2 text-2xl font-bold tracking-tight text-slate-900">
            {value}
          </p>
          {detail != null ? (
            <div className="mt-3 border-t border-slate-100 pt-3 text-xs text-slate-600">{detail}</div>
          ) : null}
        </div>
        <div className={`rounded-xl p-2.5 ${accentClasses[accent]}`}>
          <Icon className="h-5 w-5" />
        </div>
      </div>
    </div>
  );
}
